import { render, staticRenderFns } from "./BrowserInstall.vue?vue&type=template&id=8eddbfe4&scoped=true&"
import script from "./BrowserInstall.vue?vue&type=script&lang=js&"
export * from "./BrowserInstall.vue?vue&type=script&lang=js&"
import style0 from "./BrowserInstall.vue?vue&type=style&index=0&id=8eddbfe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eddbfe4",
  null
  
)

export default component.exports